module.exports = __webpack_public_path__ + "img/dt.d98c49e5.jpg";